import React from 'react';
import { DateTimeFormatter } from '../../../../../infrastructure/implementations/date-formatter';
import { DateFnsFormats } from '../../../../../infrastructure/date-formatter';
import { getFormattedTimezoneOffset, utcToZonedTime } from '../../../../../infrastructure/utils/date-fns-overrides.utils';
import { isSameDay } from 'date-fns';

interface IDateTimeArtifactDetailsProps {
    startDateTime: Date;
    endDateTime: Date;
    eventTimeZone: string;
    dateTimeFormatter: DateTimeFormatter;
}

const DateTimeArtifactDetails = ({
    startDateTime,
    endDateTime,
    eventTimeZone,
    dateTimeFormatter,
}: IDateTimeArtifactDetailsProps): JSX.Element => {

    const dayStringInEventTimezone = dateTimeFormatter.dateToFormattedString(
        startDateTime,
        DateFnsFormats.StringifiedFullDayMonthNumericDateYear,
        eventTimeZone
    );

    const startTime = dateTimeFormatter.dateToFormattedString(
        startDateTime,
        dateTimeFormatter.getLocalTimeFormat()
    );
    const endTime = dateTimeFormatter.dateToFormattedString(
        endDateTime,
        dateTimeFormatter.getLocalTimeFormat()
    );

    const startTimeInEventTimezone = dateTimeFormatter.dateToFormattedString(
        startDateTime,
        dateTimeFormatter.getLocalTimeFormat(),
        eventTimeZone
    );

    const endTimeInEventTimezone = dateTimeFormatter.dateToFormattedString(
        endDateTime,
        dateTimeFormatter.getLocalTimeFormat(),
        eventTimeZone
    );

    const isEventTimezoneTimeDifferents = startTimeInEventTimezone !== startTime;
    const timeZoneOffset = getFormattedTimezoneOffset(startDateTime);

    const localDayString = dateTimeFormatter.dateToFormattedString(
        startDateTime,
        DateFnsFormats.StringifiedFullDayMonthNumericDateYear,
    );

    return (
        <>
            <div data-test-id='meeting-start-day' className='m-bottom-4px meeting-time--start-day'>
                { dayStringInEventTimezone }
            </div>
            <div className='meeting-time--date-and-time'>
                { startTimeInEventTimezone } - { endTimeInEventTimezone }
            </div>
            { !isSameDay(startDateTime, utcToZonedTime(startDateTime, eventTimeZone)) &&
                <div className='meeting-time--text--small'>
                    { localDayString }
                </div>
            }
            { isEventTimezoneTimeDifferents &&
                <div className='meeting-time--text--small'>
                    { startTime } - { endTime } ({ timeZoneOffset })
                </div>
            }
        </>
    );
};

export default DateTimeArtifactDetails;
